import { Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import { columns } from "./config";
import Icons from "assets/icons";

const ListServiced = ({ data }) => {

  const [isShow, setIsShow] = useState(false);

  return (
    <Space direction="vertical">
      <Space
        style={{
          fontWeight: "bold",
        }}
      >
        <div>Danh sách dịch vụ đã thực hiện</div>

        {isShow ? (
          <Icons.down rev={undefined} onClick={() => setIsShow(!isShow)} />
        ) : (
          <Icons.up rev={undefined} onClick={() => setIsShow(!isShow)} />
        )}
      </Space>
      {isShow && (
        <Table
          columns={columns}
          dataSource={data?.chiDinhDaThucHien || []}
          bordered
          scroll={{ x: "100%", y: 300 }}
          pagination={false}
        />
      )}
    </Space>
  );
};

export default ListServiced;
